import { Currency } from '@round/api';
import { useNonNullContext } from '@round/utils';
import { OptionsContext } from 'contexts/OptionsContext/OptionsContext';
import { useCreatorbaseCurrencies } from 'contexts/CreatorbaseCurrencyContext';

export function useConditionalCurrencies(currencyCreatorbaseEnabled: boolean): Currency[] {
    const { currencies: defaultCurrencies } = useNonNullContext(OptionsContext);
    const { currencies: creatorbaseCurrencies } = useCreatorbaseCurrencies();

    return currencyCreatorbaseEnabled ? creatorbaseCurrencies : defaultCurrencies;
}
